module.exports = __webpack_public_path__ + "img/logo_nameless--white.3f1b7fa4.svg";